import { configureStore } from '@reduxjs/toolkit'
import vocabularyReducer from './features/vocabulary/vocabularySlice'

export const store = configureStore({
  reducer: {
    vocabulary: vocabularyReducer
  }
})


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
